/**
 *
 */
import React from 'react'
import { Icon, Tag } from 'antd'

export function PeriodoInicioTermino({ inicio, fin }) {
  return (
    <Tag color='geekblue'>
      <span style={{ textWrap: 'wrap' }}>{inicio + ' '}</span>
      <Icon type="arrow-right" />
      <span style={{ textWrap: 'wrap' }}>{' ' + fin}</span>
    </Tag>
  )
}
